import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './calculator-botswana-vaf.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
var CalculatorBotswanaVaf = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorBotswanaVaf, _super);
    function CalculatorBotswanaVaf(element) {
        return _super.call(this, element) || this;
    }
    CalculatorBotswanaVaf.prototype.init = function () {
        this.currencyForm = Array.from(this.element.querySelectorAll('.calculator-form__title--currency'));
        this.currencyCalculator = Array.from(this.element.querySelectorAll('.calculator-item__title--currency'));
        this.currencyTotal = Array.from(this.element.querySelectorAll('.js-total-currency'));
        this.inputPurchasePrice = this.element.querySelector('input[name=purchase_price]');
        this.inputTerm = this.element.querySelector('input[name=term]');
        this.inputInterest = this.element.querySelector('input[name=interest_rate]');
        this.inputBalloon = this.element.querySelector('input[name=balloon_percentage]');
        this.totalMontlyRepayment = this.element.querySelector('.js-monthly-repayment');
        this.totalPurchasePrice = this.element.querySelector('.js-purchase-price');
        this.totalRepayment = this.element.querySelector('.js-total-repayment');
        this.totalInterest = this.element.querySelector('.js-total-interest');
        this.totalresidual = this.element.querySelector('.js-total-residual');
        this.buttonCalculate = this.element.querySelector('.js-calculator-calculate');
        this.buttonTermsAndCondtions = this.element.querySelector('.js-tcs-button');
        this.buttonApply = this.element.querySelector('.js-apply-button');
        this.buttonReset = this.element.querySelector('.js-calculator-reset');
        this.containerTermsAndConditions = this.element.querySelector('.calculator-botswana-vaf__result--terms');
        if (this.element.getAttribute('data-cta-modal-id')) {
            this.dataCtaModal = this.element.getAttribute('data-cta-modal-id');
            if (this.element.getAttribute('data-cta-text')) {
                this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                this.buttonApply.innerHTML = this.dataCtaButtonText;
            }
            else {
                this.buttonApply.innerHTML = 'Apply Now';
            }
            this.buttonApply.classList.add('js-apply-now-modal-open');
            this.buttonApply.setAttribute('data-modal', this.dataCtaModal);
            this.buttonApply.classList.remove('d-none');
        }
        else {
            if (this.element.getAttribute('data-cta-link')) {
                this.dataCtaLink = this.element.getAttribute('data-cta-link');
                if (this.element.getAttribute('data-cta-text')) {
                    this.dataCtaButtonText = this.element.getAttribute('data-cta-text');
                    this.buttonApply.innerHTML = this.dataCtaButtonText;
                }
                else {
                    this.buttonApply.innerHTML = 'Apply Now';
                }
                this.buttonApply.setAttribute('href', this.dataCtaLink);
                this.buttonApply.classList.remove('d-none');
            }
        }
        if (this.element.getAttribute('data-terms-link')) {
            this.dataTermsLink = this.element.getAttribute('data-terms-link');
            if (this.element.getAttribute('data-terms-text')) {
                this.dataTermsButtonText = this.element.getAttribute('data-terms-text');
            }
            else {
                this.dataTermsButtonText = "Terms and conditions";
            }
            this.buttonTermsAndCondtions.setAttribute('href', this.dataTermsLink);
            this.buttonTermsAndCondtions.innerHTML = this.dataTermsButtonText;
            this.containerTermsAndConditions.classList.remove('d-none');
        }
        if (this.element.getAttribute('data-disclaimer')) {
            this.dataTermsDisclaimer = this.element.getAttribute('data-disclaimer');
        }
        this.calculate();
        TooltipsService.initTooltips();
    };
    CalculatorBotswanaVaf.prototype.bindEvents = function () {
        var _this = this;
        this.buttonCalculate.addEventListener('click', function (evt) {
            _this.calculate();
        });
        this.buttonReset.addEventListener('click', function (evt) {
            _this.totalMontlyRepayment.innerHTML = "-";
            _this.totalPurchasePrice.innerHTML = "-";
            _this.totalRepayment.innerHTML = "-";
            _this.totalInterest.innerHTML = "-";
            _this.totalresidual.innerHTML = "-";
        });
    };
    // calculate() {
    // 	let purchasePrice = 0;
    // 	let interestRate = 0;
    // 	let term = 0;
    // 	let balloonPercentage = 0;
    // 	let inputPurchasePrice = parseFloat(this.inputPurchasePrice.value);
    // 	let inputInterestRate = parseFloat(this.inputInterest.value);
    // 	let inputTerm = parseFloat(this.inputTerm.value);
    // 	let inputBalloonPayment = parseFloat(this.inputBalloon.value);
    // 	// Validate inputs and set default values if not provided
    // 	purchasePrice = inputPurchasePrice;
    // 	interestRate = inputInterestRate;
    // 	term = inputTerm;
    // 	balloonPercentage = inputBalloonPayment;
    // 	// Calculate the balloon amount
    // 	let balloonAmt = balloonPercentage * purchasePrice / 100;
    // 	// Adjust the loan amount by subtracting the balloon amount
    // 	let loanAmount = purchasePrice - balloonAmt;
    // 	// Calculate the monthly repayment based on the reduced loan amount
    // 	let pmt = -this.PMT(interestRate / 1200, term, loanAmount, 0, 0);
    // 	// Calculate the total repayment and total interest paid
    // 	let totalRepayment = (pmt * term) + balloonAmt;  // Add the balloon payment at the end
    // 	let totalInterestPaid = totalRepayment - purchasePrice;
    // 	// Calculate the total residual value
    // 	let totalResidual = -this.PMT(interestRate / 1200, term * 12, loanAmount, balloonAmt, 0);
    // 	// Display the calculated values
    // 	this.totalPurchasePrice.innerHTML = this.roundFormatter(purchasePrice, 2, true);
    // 	this.totalMontlyRepayment.innerHTML = this.roundFormatter(pmt, 2, true);
    // 	this.totalRepayment.innerHTML = this.roundFormatter(totalRepayment, 2, true);
    // 	this.totalInterest.innerHTML = this.roundFormatter(totalInterestPaid, 2, true);
    // 	// Update the residual value in the UI (js-total-residual)
    // 	this.totalresidual.innerHTML = this.roundFormatter(totalResidual, 2, true);
    // }	
    CalculatorBotswanaVaf.prototype.calculate = function () {
        var inputPurchasePrice = parseFloat(this.inputPurchasePrice.value);
        var inputInterestRate = parseFloat(this.inputInterest.value);
        var inputTerm = parseFloat(this.inputTerm.value); // in months
        var inputBalloonPayment = parseFloat(this.inputBalloon.value); // % value
        // Defaults / Sanitization
        var purchasePrice = inputPurchasePrice || 0;
        var interestRate = inputInterestRate || 0;
        var term = inputTerm || 0;
        var balloonPercentage = inputBalloonPayment || 0;
        // Balloon amount 
        var balloonAmt = balloonPercentage * purchasePrice / 100;
        var loanAmount = purchasePrice;
        // Monthly repayment
        var monthlyRate = interestRate / 1200;
        var pmt = -this.PMT(monthlyRate, term, loanAmount, -balloonAmt, 0);
        // Total repayment
        var totalRepayment = (pmt * term) + balloonAmt;
        // Interest
        var totalInterestPaid = totalRepayment - purchasePrice;
        // UI Display
        this.totalPurchasePrice.innerHTML = this.roundFormatter(purchasePrice, 2, true);
        this.totalMontlyRepayment.innerHTML = this.roundFormatter(pmt, 2, true);
        this.totalRepayment.innerHTML = this.roundFormatter(totalRepayment, 2, true);
        this.totalInterest.innerHTML = this.roundFormatter(totalInterestPaid, 2, true);
        this.totalresidual.innerHTML = this.roundFormatter(balloonAmt, 2, true);
    };
    CalculatorBotswanaVaf.prototype.PV = function (rate, nper, pmt, fv, type) {
        var pv_value = 0;
        rate = parseFloat(rate);
        nper = parseFloat(nper);
        pmt = parseFloat(pmt);
        fv = parseFloat(fv);
        if (nper == 0) {
            alert("Why do you want to test me with zeros?");
            return (0);
        }
        if (rate == 0) { // Interest rate is 0
            pv_value = -(fv + (pmt * nper));
        }
        else {
            var x = Math.pow(1 + rate, -nper);
            var y = Math.pow(1 + rate, nper);
            pv_value = -(x * (fv * rate - pmt + y * pmt)) / rate;
        }
        return pv_value;
    };
    CalculatorBotswanaVaf.prototype.round = function (expr, decplaces) {
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
    };
    CalculatorBotswanaVaf.prototype.roundFormatter = function (expr, decplaces, formatted) {
        if (formatted === void 0) { formatted = false; }
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        var valueFull = str.substring(0, decpoint);
        var valueDecimal = str.substring(decpoint, str.length);
        if (formatted) {
            valueFull = valueFull.replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
        }
        return valueFull + '.' + valueDecimal;
    };
    CalculatorBotswanaVaf.prototype.formatter = function (value) {
        return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    };
    CalculatorBotswanaVaf.prototype.PMT = function (rate, period, value, futurevalue, type) {
        if (rate === void 0) { rate = 0; }
        if (period === void 0) { period = 0; }
        if (value === void 0) { value = 0; }
        if (futurevalue === void 0) { futurevalue = 0; }
        if (type === void 0) { type = 0; }
        if (!futurevalue)
            futurevalue = 0;
        if (!type)
            type = 0;
        if (rate == 0)
            return -(value + futurevalue) / period;
        var pvif = Math.pow(1 + rate, period);
        var pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);
        if (type == 1) {
            pmt /= (1 + rate);
        }
        ;
        return pmt;
    };
    return CalculatorBotswanaVaf;
}(Base));
export { CalculatorBotswanaVaf };



//////////////////
// WEBPACK FOOTER
// ./components-botswana/calculator-botswana-vaf/calculator-botswana-vaf.component.ts
// module id = 778
// module chunks = 0